module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mountedFinished) ? _c('div', {
    key: "main",
    staticClass: "row main-layout"
  }, [_vm._l((_vm.all_functions), function(subfun) {
    return _c('div', {
      class: {
        'col-8': subfun.title === '藥物管理', 'col-4': subfun.title === '藥櫃設定'
      }
    }, [_c('div', {
      staticClass: "main-sublayout"
    }, [_c('p', {
      staticClass: "main-sublayout--title "
    }, [_vm._v(_vm._s(subfun.title))]), _vm._v(" "), _vm._l((subfun.functions), function(fun) {
      return (fun.privilege) ? _c('div', {
        class: {
          'function-button': true,
          'd-inline-block': true,
          'm-1': true,
          'danger-button': fun.url_name === 'disabledDevices',
            'not-ready': fun.ready === false,
        },
        attrs: {
          "id": fun.url_name
        }
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: fun.url_name
          }
        }
      }, [_c('div', {
        staticClass: "icon-wrap"
      }, [_c('img', {
        attrs: {
          "src": ("/static/svg/" + (fun.icon_name)),
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "text-center"
      }, [_vm._v("\n                " + _vm._s(fun.name) + "\n              ")]), _vm._v(" "), (fun.url_name === 'removeOutdatedDrug' && _vm.outdateCount !== 0) ? _c('div', {
        staticClass: "badge-alert"
      }, [_c('span', [_vm._v(_vm._s(_vm.outdateCount))])]) : _vm._e(), _vm._v(" "), (fun.url_name === 'refillDrug' && _vm.lowCount !== 0) ? _c('div', {
        staticClass: "badge-alert"
      }, [_c('span', [_vm._v(_vm._s(_vm.lowCount))])]) : _vm._e(), _vm._v(" "), (fun.url_name === 'storageError' && _vm.storageErrorCount !== 0) ? _c('div', {
        staticClass: "badge-alert"
      }, [_c('span', [_vm._v(_vm._s(_vm.storageErrorCount))])]) : _vm._e()])], 1) : _vm._e()
    })], 2)])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "bottom-layout"
  }, [_c('div', {
    staticClass: "clock"
  }, [_c('Clock'), _vm._v(" "), _c('span', {
    staticClass: "clock-text"
  }, [_c('p', [_vm._v("現在時間")]), _vm._v("\n              " + _vm._s(_vm.time) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "system-env-wrap"
  }, [_c('div', {
    staticClass: "system-env"
  }, [_c('span', [_vm._v("藥櫃溫度")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$store.state.temperature) + " "), _c('span', [_vm._v("℃")])])]), _vm._v(" "), _c('div', {
    staticClass: "system-env"
  }, [_c('span', [_vm._v("藥櫃濕度")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$store.state.humidity) + " "), _c('span', [_vm._v("%")])])])]), _vm._v(" "), _c('span', [_c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("版本: " + _vm._s(_vm.version))]), _vm._v(" "), (_vm.$store.state.device.systemArea !== null) ? _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("藥櫃位置：" + _vm._s(_vm._f("areaFormat")(_vm.$store.state.device.systemArea)))]) : _vm._e()])])])], 2) : _c('div', {
    key: "loading",
    staticClass: "row main-layout"
  }, [_c('div', {
    staticClass: "main-layout--center"
  }, [_c('ClipLoader'), _vm._v(" "), _c('p', [_vm._v("更新系統資訊中")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01cae892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 1364
// module chunks = 1